import GrabbableWindow from './GrabbableWindow.js';
import DPR from './DPR.js'
import CanvasEyedropper from './CanvasEyedropper.js';
import DragToolUsable from './DragToolUsable.js';

export default class PreviewWindow {
  constructor(imageDataManager, eyedropperPopup, colorManager, buttons, download, autoFocus, elContainer, ondestroy) {
    this._imageDataManager = imageDataManager;
    this._download = download;
    this._ondestroy = ondestroy;
    this._scale = 2;
    this._delay = Math.floor(1000 / 4);
    const div = document.createElement('div');
    div.innerHTML = `
      <div id="previewWindowWrapper" class="previewWindowWrapper" data-auto-focus-to-children="1">
        <section class="previewWindow">
          <div class="background floatingWindow"></div>
          <canvas></canvas>
          <div class="scale"></div>
        </section>
        <section class="previewMenu floatingWindow hidden">
          <p class="buttons">
            <svg class="button" data-name="download" viewBox="0 0 512 512" data-help="preview-download"><use href="#svgDownload"></use></svg>
            <span class="playButtonWrapper">
              <svg class="button" data-name="play" viewBox="-.5 0 8 8"><use href="#svgPlay"></use></svg>
              <svg class="button hidden" data-name="pause" viewBox="-1 0 8 8"><use href="#svgPause"></use></svg>
            </span>
            <svg class="button stroke" data-name="zoomIn" viewBox="0 0 17.5 17.5"><use href="#svgZoomIn"></use></svg>
            <svg class="button stroke" data-name="zoomOut" viewBox="0 0 17.5 17.5"><use href="#svgZoomOut"></use></svg>
            <svg class="button" data-name="flipX" data-help="preview-flip-x" viewBox="0 0 485.383 485.383"><use href="#svgFlip"></use></svg>
            <svg class="button" data-name="delete" viewBox="0 0 473 473"><use href="#svgDelete"></use></svg>
          </p>
          <p class="inputs">
            <label data-help="fps"><input type="number" name="fps" value="4" min="1" max="32">FPS</label>
            <label><input type="checkbox" name="border" checked>Border</label>
          </p>
        </section>
      </div>
    `;
    this._elWrapper = div.firstElementChild;
    elContainer.appendChild(this._elWrapper);
    autoFocus.add(this._elWrapper);
    autoFocus.raise(this._elWrapper);
    this._elSection = this._elWrapper.querySelector('.previewWindow');
    this._elBackground = this._elSection.querySelector('.background');
    this._elScale = this._elSection.querySelector('.scale');
    this._elCanvas = this._elSection.querySelector('canvas');
    this._menu = new PopupMenu(this._elWrapper.querySelector('.previewMenu'), (name, target) => this._exec(name, target));
    this._elInputFPS = this._menu.element.querySelector('input[name="fps"]');
    this._elInputBorder = this._menu.element.querySelector('input[name="border"]');
    {
      const elButtons = this._elWrapper.querySelector('.buttons');
      this._objElButton = {
        play: elButtons.querySelector('[data-name="play"]'),
        pause: elButtons.querySelector('[data-name="pause"]'),
      };
    }
    this._grabbableWindow = new GrabbableWindow(this._elSection, null);
    this._isPlaying = false;
    this._frameIdx = 0;
    this._now = 0;

    this._updateCanvasSz();

    this._canvasEyedropper = new CanvasEyedropper(this._elCanvas, colorManager, eyedropperPopup);

    // DragToolUsableの設定
    this._dragToolUsable = new DragToolUsable(this._elCanvas, buttons, (x, y) => {
    }, (x, y) => {
    }, (x, y) => {
      const usingDragTool = this._canvasEyedropper;
      usingDragTool.start(x, y);
      this._elCanvas.style.cursor = 'var(--cursor-eyedropper)';
      return usingDragTool;
    }, () => {
      this._elCanvas.style.cursor = '';
    });
    
    //-- bind
    this._showMenu = this._showMenu.bind(this);
    this._hideMenu = this._hideMenu.bind(this);
    this._play = this._play.bind(this);

    //-- addEventListener
    this._elWrapper.addEventListener('mouseenter', () => {
      if(!this._grabbableWindow.isGrabbing) this._showMenu();
    });
    this._elWrapper.addEventListener('mouseleave', () => {
      this._hideMenu();
    });
    this._elSection.addEventListener('mouseup', e => {
      if(e.button === 0) this._showMenu();
    });
    this._elSection.addEventListener('mousedown', e => {
      if(e.button === 0 && this._grabbableWindow.isGrabbing) this._hideMenu();
    });
    /*this._elCanvas.addEventListener('transitionstart', e => {
      switch(e.propertyName) {
      case 'width':
      case 'height':
        this._elCanvas.style.opacity = '0';
        break;
      }
    });
    this._elCanvas.addEventListener('transitionend', e => {
      switch(e.propertyName) {
      case 'width':
      case 'height':
        this._elCanvas.style.opacity = '1';
        break;
      }
    });*/
    this._elInputFPS.addEventListener('input', () => this._setPlayInterval());
    this._setPlayInterval();
    this._elInputBorder.addEventListener('input', e => this._setFrame(e.target.checked));
    /*document.addEventListener('resizeCanvas', () => {
      const padding = Math.round(parseFloat(getComputedStyle(this._elSection).padding));
      this._elSection.style.padding = this._elBackground.style.borderWidth = padding + 'px';
    });*/

    this.update();
  }
  show(yes) {
    if(yes) {
      this._elSection.classList.remove('hidden');
      this._grabbableWindow.correctPosition();
    } else {
      this._elSection.classList.add('hidden');
    }
  }
  _showMenu() {
    const {x, y, width, height} = this._elSection.getBoundingClientRect();
    this._menu.move(x, y, width, height);
    this._menu.show();
  }
  _hideMenu() {
    this._menu.hide();
    this._elInputFPS.blur();
  }
  update() {
    this._imageDataManager.drawPreview(this._elCanvas, this._imageDataManager.frameIdx, false, this._isPlaying);
    this._updateCanvasSz();
  }
  updateIf(imageDataManager) {
    if(this._imageDataManager === imageDataManager) {
      this.update();
    }
  }
  _updateCanvasSz() {
    this._elCanvas.style.width = this._elCanvas.width * DPR.div(this._scale) + 'px';
    this._elCanvas.style.height = this._elCanvas.height * DPR.div(this._scale) + 'px';
    this._elScale.innerText = this._scale + 'x';
  }
  _play() {
    if(!this._isPlaying) return;
    const now = performance.now();
    if(now - this._now >=  this._delay) {
      this._now = now;
      const idx = this._frameIdx % this._imageDataManager.frameSz;
      this._imageDataManager.drawPreview(this._elCanvas, idx, false);
      ++this._frameIdx;
    }
    requestAnimationFrame(this._play);
  }
  _exec(name, target) {
    switch(name) {
    case 'download':
      target.classList.add('disabled');
      this._imageDataManager.exportGIF(this._scale, this._delay, dataURL => {
        this._download(dataURL, 'gif');
        target.classList.remove('disabled');
      });
      break;
    case 'play':
      if(this._imageDataManager.frameSz > 1) {
        this._isPlaying = true;
        this._play();
        this._objElButton.play.classList.add('hidden');
        this._objElButton.pause.classList.remove('hidden');
      }
      break;
    case 'pause':
      this._isPlaying = false;
      this.update();
      this._objElButton.play.classList.remove('hidden');
      this._objElButton.pause.classList.add('hidden');
      break;
    case 'zoomIn':
      {
        const max = parseInt(this._elInputFPS.max);
        this._scale = Math.min(max, this._scale + 1);
        this._updateCanvasSz();
      }
      break;
    case 'zoomOut':
      {
        const min = parseInt(this._elInputFPS.min);
        this._scale = Math.max(min, this._scale - 1);
        this._updateCanvasSz();
      }
      break;
    case 'flipX':
      this._elCanvas.classList.toggle('flipX');
      break;
    case 'delete':
      this.delete();
      break;
    }
  }
  delete() {
    this._elWrapper.remove();
    this._ondestroy(this);
  }
  _download(href, fileName) {
    const a = document.createElement('a');
    a.href = href;
    a.download = fileName;
    a.click();
  }
  _setPlayInterval() {
    const min = parseInt(this._elInputFPS.min);
    const max = parseInt(this._elInputFPS.max);
    const value = parseInt(this._elInputFPS.value);
    const fps = isNaN(value) ? min : Math.max(min, Math.min(value, max));
    this._elInputFPS.value = fps;
    this._delay = Math.floor(1000 / fps);
  }
  get delay() {
    return this._delay;
  }
  _setFrame(yes) {
    if(yes) {
      this._elSection.classList.remove('transparent');
    } else {
      this._elSection.classList.add('transparent');
    }
    this.update();
  }
  get _hasFrame() {
    return !this._elSection.classList.contains('transparent');
  }
  // save() {
  //   return {
  //     scale: this._scale,
  //     fps: parseInt(this._elInputFPS.value),
  //   };
  // }
  // restore({scale, fps}) {
  //   this._scale = scale;
  //   this._updateCanvasSz();
  //   this._elInputFPS.value = fps;
  //   this._setPlayInterval();
  // }
}

export class PopupMenu {
  constructor(elMenu, exec) {
    this._elMenu = elMenu;

    this._elMenu.addEventListener('click', e => {
      if(e.target.classList.contains('button')) {
        exec(e.target.dataset.name, e.target);
      }
    });
  }
  get element() {
    return this._elMenu;
  }
  show() {
    this._elMenu.classList.remove('hidden');
  }
  hide() {
    this._elMenu.classList.add('hidden');
  }
  isShown() {
    return !this._elMenu.classList.contains('hidden');
  }
  move(x, y, width, height) {
    this._elMenu.style.left = x + width / 2 + 'px';
    this._elMenu.style.top = y + height + 'px';
    this._correctPosition();
  }
  _correctPosition() {
    const rect = this._elMenu.getBoundingClientRect();
    const {innerWidth, innerHeight} = window;
    if(rect.x < 0) {
      this._setLeft(0);
    } else if(innerWidth < rect.right) {
      this._setLeft(innerWidth - rect.width);
    }
    if(rect.y < 0) {
      this._setTop(0);
    } else if(innerHeight < rect.bottom) {
      this._setTop(innerHeight - rect.height - innerHeight * .02);
    }
  }
  _setLeft(x) {
    const left = parseFloat(getComputedStyle(this._elMenu).left);
    x += left - this._elMenu.getBoundingClientRect().x;
    this._elMenu.style.left = x + 'px';
  }
  _setTop(y) {
    const top = parseFloat(getComputedStyle(this._elMenu).top);
    y += top - this._elMenu.getBoundingClientRect().y;
    this._elMenu.style.top = y + 'px';
  }
}
